import React, { useEffect, useState } from 'react';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import SecondaryTabbedComponent from '../../shared/components/layout/SecondaryTabbedComponent';
import AccommodationDetails from './AccommodationDetails';
import Button from '../../shared/components/ui/Button';
import SaleOverview from './SaleOverview';
import DealsDetails from './DealsDetails';
import ScheduleDetails from './ScheduleDetails';
import ActivityList from './ActivityList';
import SaleAttachmentList from './SaleAttachmentList';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getLeadByID } from '../services/api/implementation/impl';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Logs from './Logs';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import Loader from '../../shared/components/ui/Loader';

const SaleDetails = () => {
  const { id } = useParams();
  const { collapsed } = useSidebar();
  const userId = Cookies.get('userId');

  // Track component mount

  // Track page view
  useEffect(() => {
    mixpanel.track('Sale Details Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    mixpanel.track('Sale Details Viewed', {
      user_id: userId,
      sale_id: id,
      timestamp: new Date().toISOString()
    });
  }, []);

  const {
    data: leadbyId,
    isLoading,
    error,
    refetch: refetchLeadbyId
  } = useQuery({
    queryKey: ['leadById', parseInt(id)],
    queryFn: async () => {
      const res = await getLeadByID(parseInt(id));
      return res;
    },
    enabled: !!id, // Only run the query if id is truthy
    onSuccess: (data) => {
      mixpanel.track('Lead By ID API Success', {
        user_id: userId,
        lead_id: id,
        lead_name: data?.user?.name,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      mixpanel.track('Lead By ID API Failed', {
        user_id: userId,
        lead_id: id,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  /* 
    Meta data
  */
  const secondaryTabbedComponentMetaData = {
    tabs: ['Stages', 'Logs']
  };

  /* 
    Local state
  */
  const [secondaryTab, setSecondaryTab] = useState('Stages');

  /* 
    Data fetching
  */
  const { data: sale } = useState(null);

  console.log({ leadbyId });
  /* 
    JSX
  */
  return (
    <>
      <Loader isVisible={isLoading} />
      {/* Main content */}
      <Layout>
        {/* Header */}
        <div
          className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
    ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
  `}>
          <Header data={{ name: `Lead Details` }} backArrow={true} />
        </div>

        {/* Secondary Tabbed content */}
        <div
          className={` ${collapsed ? 'w-[100%] pl-3' : 'w-[100%]'} flex flex-col justify-start items-center mt-[4rem]`}>
          <SaleOverview leadID={leadbyId?.id} />
        </div>

        <div
          className={` ${collapsed ? 'w-[100%] pl-7 pr-4' : 'w-[100%] pl-4 pr-4'} flex flex-col justify-start items-center `}>
          <SecondaryTabbedComponent
            data={secondaryTabbedComponentMetaData}
            activePrimary={secondaryTab}
            onChangePrimaryTab={(tab) => {
              // Track tab change
              mixpanel.track('Sale Details Tab Changed', {
                user_id: userId,
                sale_id: id,
                tab: tab,
                timestamp: new Date().toISOString()
              });
              setSecondaryTab?.(tab);
            }}
            rounded={true}></SecondaryTabbedComponent>

          {secondaryTab === 'Stages' && (
            <ActivityList salesId={leadbyId?.id ? parseInt(leadbyId?.id) : undefined} />
          )}
          {secondaryTab === 'Logs' && <Logs salesId={id ? parseInt(id) : undefined} />}
        </div>
        {/* {secondaryTab === 'Deals' && (
          <div className="w-full h-full">
            <DealsDetails />
          </div>
        )} */}

        {/* Attachments content */}
        {/* {secondaryTab === 'Attachments' && (
          <div className=" w-full h-full ">
            <SaleAttachmentList />
          </div>
        )} */}

        {/* Schedule */}
        {/* {secondaryTab === 'Schedule' && (
          <div className=" w-full h-full ">
            <ScheduleDetails />
          </div>
        )} */}
      </Layout>
    </>
  );
};

export default SaleDetails;
